export default __webpack_public_path__ + "static/media/img-video-finally.b6ea9513.jpg";